import { Button, Col, Form, Input, TimePicker, InputNumber, Row, Select, Space, Switch, Tag } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx'
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
import systematic from '../../../config/systematic';
import { SocketContext } from '../../../App';

const SpecialPrintConfigurationEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    // const { sendPageData } = data;


    /**打印单类型数据 */
    const [printTypeData, setPrintTypeData] = useState<Array<any>>([]);
    /**打印机数据 */
    const [printData, setPrintData] = useState<Array<any>>([]);

    /**部门数据 */
    const [deptData, setDeptData] = useState<Array<any>>([]);

    const useContextData = useContext(SocketContext);
    const { contextData, } = useContextData;
    /** 菜品类型数据 */
    const [foodTypeData, setFoodTypeData] = useState<any>();
    const [branchStoreMenuWarehouseData, setBranchStoreMenuWarehouseData] = useState<Array<any>>()
    const ref = useRef<any>(undefined);
    /** 后端数据wmService */
    let wmService: any = systematic.wmService;
    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;

        }
        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: "generalData",
                apiExtend: 'showLists',
                apiVariable: "printOrderType@foodType",
            }).then(res => {
                if (res.success) {
                    const { printOrderType, foodType } = res.data
                    setPrintTypeData(printOrderType);
                    setFoodTypeData(foodType);
                }
            })

            fetchApi.GET(wmService, {
                apiId: "printer",
                apiExtend: 'showList',
                apiData: {
                    branchStoreId: contextData?.currentBranchStoreId,
                    mountDataOptions: {
                        userMount: {
                            isDept: true,
                        }
                    },
                }
            }).then(res => {
                if (res.success) {

                    setPrintData(res.data)
                }
            })

            fetchApi.GET(wmService, {
                apiId: "branchStoreMenuWarehouse",
                apiExtend: 'showMenuList',
                apiData: {
                    branchStoreId: contextData?.currentBranchStoreId,
                    mountDataOptions: {
                        userMount: {
                            isDept: true,
                        }
                    },
                }
            }).then(res => {
                if (res.success) {

                    setBranchStoreMenuWarehouseData(res.data)
                }
            })

            fetchApi.GET(wmService, {
                apiId: "dept",
                apiExtend: 'showList',
                apiData: {
                    branchStoreId: contextData?.currentBranchStoreId,
                    mountDataOptions: {
                        userMount: {
                            isDept: true,
                        }
                    },
                }
            }).then(res => {
                if (res.success) {

                    setDeptData(res.data)
                }
            })
            // fetchApi.GET(wmService, {
            //     apiId: 'generalData',
            //     apiVariable: 'foodType',
            //     apiExtend: 'showList'
            // }).then(res => {
            //     if (res.success) {
            //         setFoodTypeData(res.data);
            //     }
            // });


        }

        fetchData()
    }, [])

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        dateColumnName: ['startTime', 'endTime'],
        apiId: 'specialPrintConfiguration',
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '特殊配置打印机'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>
                    <Row >
                        <Col span={12}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="打印单类型"
                                name="printType"
                                rules={[{ required: true, message: '请选择打印单类型!' }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="打印类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(printTypeData, 'name')}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="打印机"
                                name="printerId"
                                rules={[{ required: true, message: '请选择打印机!' }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="打印机"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(printData, 'printerName')}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="部门"
                                name="deptId"
                            >
                                <Select
                                    // disabled={data.type === "NEW" ? false : true}
                                    showSearch
                                    placeholder="部门"
                                    optionFilterProp="children"

                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(deptData,{includeNull:true,itemName:"deptName"})}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="门店菜"
                                name="branchStoreMenuWarehouseId"
                            >
                                <Select
                                    // disabled={data.type === "NEW" ? false : true}
                                    showSearch
                                    placeholder="门店菜"
                                    optionFilterProp="children"
                                    // onSearch={(e) => getList.search('branchStoreMenuWarehouse', setBranchStoreMenuWarehouseData, e,
                                    //     {"apiExtend":"showMenuList", andWhereObj: { branchStoreId: contextData?.currentBranchStoreId } }
                                    // )}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(branchStoreMenuWarehouseData, {includeNull:true,itemName:"foodName"})}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="菜品类型"
                                name="foodTypeId"
                            >
                                <Select
                                    placeholder="菜品类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(foodTypeData, {
                                        includeNull: true
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="开始时间"
                                name="startTime">
                                <TimePicker
                                    format="HH:mm" />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="结束时间"
                                name="endTime">
                                <TimePicker
                                    format="HH:mm" />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="打印页数"
                                name="copies"

                            >
                                <InputNumber defaultValue={1} min={1} />
                            </Form.Item>
                        </Col>


                        <Col span={8}>
                            <Form.Item
                                label="静默打印"
                                name="isSilent"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="显示打印页设置"
                                name="isPrinterPage"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>


                        <Col span={8}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>


                    </Row>









                </Form>
            </AntDraggableModal>
        </>
    )
}

export default SpecialPrintConfigurationEdit;